var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7495 10.5V18.8333C18.7495 19.0101 18.6793 19.1797 18.5542 19.3047C18.4292 19.4298 18.2597 19.5 18.0828 19.5H3.74951C3.5506 19.5 3.35983 19.421 3.21918 19.2803C3.07853 19.1397 2.99951 18.9489 2.99951 18.75V8.25C2.99951 8.05109 3.07853 7.86032 3.21918 7.71967C3.35983 7.57902 3.5506 7.5 3.74951 7.5H7.99951C8.16179 7.5 8.31969 7.55263 8.44951 7.65L11.0495 9.6C11.1793 9.69737 11.3372 9.75 11.4995 9.75H17.9995C18.1984 9.75 18.3892 9.82902 18.5298 9.96967C18.6705 10.1103 18.7495 10.3011 18.7495 10.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99951 6.5V4.25C5.99951 4.05109 6.07853 3.86032 6.21918 3.71967C6.35983 3.57902 6.5506 3.5 6.74951 3.5H10.9995C11.1618 3.5 11.3197 3.55263 11.4495 3.65L14.0495 5.6C14.1793 5.69737 14.3372 5.75 14.4995 5.75H20.9995C21.1984 5.75 21.3892 5.82902 21.5298 5.96967C21.6705 6.11032 21.7495 6.30109 21.7495 6.5V14.8333C21.7495 14.9209 21.7323 15.0076 21.6988 15.0885C21.6653 15.1693 21.6162 15.2428 21.5542 15.3047C21.4923 15.3666 21.4189 15.4157 21.338 15.4493C21.2571 15.4828 21.1704 15.5 21.0828 15.5H18.7495",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.7bc0704493fb8b6635fa5fc651995aee.svg";
export { ForwardRef as ReactComponent };